<template>
  <div>
    <button
      @click="showConfirm = true"
      class="bg-red-50 text-red-600 border border-red-200 px-4 py-1 rounded hover:bg-red-100 disabled:opacity-50 disabled:cursor-not-allowed"
      :disabled="closing"
    >
      Close Visit
    </button>

    <ConfirmationModal
      :show="showConfirm"
      :showLoader="closing"
      title="Close Visit"
      :message="`Visit ${visit.VisitCode || ''} for ${visit.patient?.FullName || 'this patient'} will be archived immediately. It can be reopened later from Archived Visits.`"
      @cancel="showConfirm = false"
      @confirm="handleClose"
    />
  </div>
</template>

<script>
import apiClient from "@/services/api";
import ConfirmationModal from "@/views/modals/shared/ConfirmationModal.vue";

export default {
  name: "CloseVisitButton",
  components: { ConfirmationModal },
  props: {
    visit: { type: Object, required: true },
  },
  emits: ["closed"],
  data() {
    return {
      showConfirm: false,
      closing: false,
    };
  },
  methods: {
    async handleClose() {
      this.closing = true;
      try {
        const response = await apiClient.archiveVisit(this.visit.VisitId);
        if (response.success) {
          this.$toast?.success?.("Visit closed successfully.");
          this.showConfirm = false;
          this.$emit("closed");
        } else {
          this.$toast?.error?.(response.message || "Failed to close visit.");
        }
      } catch (error) {
        this.$toast?.error?.(error?.message || "Failed to close visit.");
      } finally {
        this.closing = false;
      }
    },
  },
};
</script>
